const imgZoom = document.querySelectorAll('.mdImgZoom')
if (imgZoom) {
  imgZoom.forEach((parent) => {
    const openBtn = parent.querySelector('.js-modal-open')
    const closeBtn = parent.querySelector('.js-modal-close')
    const modal = parent.querySelector('.js-modal')

    openBtn.addEventListener('click', () => {
      document.body.classList.add('lock-sp')
      modal.classList.add('active')
    })

    closeBtn.addEventListener('click', () => {
      document.body.classList.remove('lock-sp')
      modal.classList.remove('active')
    })
  })
}
